"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstItemByLayout = getFirstItemByLayout;
exports.isOutro = isOutro;
exports.normalizeCaptionObject = normalizeCaptionObject;
exports.getCaptionByGuid = getCaptionByGuid;
exports.sortCaptions = sortCaptions;
exports.getLastCaptionByType = getLastCaptionByType;
exports.getCaptionStyles = getCaptionStyles;
exports.getOutro = getOutro;
exports.setCaptionFont = setCaptionFont;
exports.setCaptionColors = setCaptionColors;
exports.setCaptionTextTransform = setCaptionTextTransform;
exports.setCaptionAnimation = setCaptionAnimation;
exports.isFontSupport = isFontSupport;
exports.resetCaptionFonts = resetCaptionFonts;
exports.setCaptionStyle = setCaptionStyle;
exports.setCaptionTextAlign = setCaptionTextAlign;
exports.setCaptionValue = setCaptionValue;
exports.pushOutroTiming = pushOutroTiming;
exports.getNewCaptionTiming = getNewCaptionTiming;
exports.getCaptionTrimStartOptions = getCaptionTrimStartOptions;
exports.getCaptionTrimEndOptions = getCaptionTrimEndOptions;
exports.getCaptionDragTimeOptions = getCaptionDragTimeOptions;
exports.setOutroValue = setOutroValue;
exports.setInputsValue = setInputsValue;
exports.setMedia = setMedia;
exports.setTemplateLogo = setTemplateLogo;
exports.getCaptionByTime = getCaptionByTime;
exports.getCaptionsPropsForReports = getCaptionsPropsForReports;
exports.getCaptionValueWithoutLineBreak = getCaptionValueWithoutLineBreak;
exports.getReportOutroFields = getReportOutroFields;
exports.validateCaptionSizeAndPosition = validateCaptionSizeAndPosition;
exports.getCaptionFont = getCaptionFont;
exports.setColorsByKey = setColorsByKey;
exports.getConfigByName = getConfigByName;
exports.getCaptionsByType = getCaptionsByType;
Object.defineProperty(exports, "formatInputsAsArray", {
  enumerable: true,
  get: function () {
    return _inputsUtils.default;
  }
});

var _color = _interopRequireDefault(require("color"));

var _lodash = _interopRequireDefault(require("lodash"));

var _colorUtils = require("./color-utils");

var _promoAnimation = require("promo-animation");

var _inputsUtils = _interopRequireDefault(require("./inputs-utils"));

var _mathUtils = require("./math-utils");

var _captionInputs = _interopRequireDefault(require("../config/caption-inputs"));

var _outroInputs = _interopRequireDefault(require("../config/outro-inputs"));

var _logoUtils = require("./logo-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CAPTION_GAP_TIME = 1;
const CAPTION_MIN_TIME = 3;

function getCaptionByGuid(data, guid) {
  return data.find(item => item.guid === guid);
}

function getFirstItemByLayout(data, layout) {
  return data.find(item => item.layout === layout);
}

function isOutro(caption) {
  return caption.type === 'outro';
}

function isTemplate2(caption) {
  return caption.type === 'template2';
}

function getOutro(data) {
  return data.find(item => item.type === 'outro');
} // caption is lottie object


function getTextTransform(lottie) {
  let textTransform = 'none';

  if (isOutro(lottie)) {
    const key = Object.keys(_outroInputs.default)[0];

    if (lottie.data[key].textTransform) {
      textTransform = lottie.data[key].textTransform;
    }
  } else if (lottie.data.textTransform) {
    textTransform = lottie.data.textTransform;
  }

  return textTransform;
}

function getOutroInputs(lottie) {
  const inputs = {};
  Object.keys(_outroInputs.default).forEach(atrr => {
    inputs[atrr] = lottie.data[atrr].value;
  });
  return inputs;
}

function getConfigByName(name, type) {
  let config = (0, _promoAnimation.GetTemplate)(name);
  const formattedInputs = (0, _inputsUtils.default)(config.inputs, _captionInputs.default, _outroInputs.default);

  if (type === 'outro') {
    config = { ...config,
      ..._outroInputs.default,
      inputs: formattedInputs
    };
  } else {
    config = { ...config,
      ..._captionInputs.default,
      inputs: formattedInputs
    };
  }

  return config;
}

function formatDataByConfig(caption, data, config, isoutro) {
  const {
    name,
    value,
    fonts,
    colors,
    style,
    textAlign,
    isStatic
  } = data;
  let fontID = null;

  if (fonts && fonts[0]) {
    const f = fonts[0];
    fontID = `${_lodash.default.kebabCase(f.font + f.weight)}`;
  }

  const formatedData = {
    values: {},
    colors: {},
    media: {},
    logo: {},
    name,
    font: fontID,
    textAlign
  };

  if (!isoutro) {
    formatedData.rect = style;
    formatedData.value = value;

    if (isStatic !== undefined) {
      formatedData.isStatic = isStatic;
    }
  } else {
    formatedData.style = style;
  }

  formatedData.colors = (0, _colorUtils.normalizeColorsObject)(colors);

  if (Array.isArray(config.inputs)) {
    config.inputs.forEach(fld => {
      if (data[fld.name]) {
        switch (fld.type) {
          case 'color':
            formatedData.colors[fld.name] = data[fld.name].value;
            break;

          case 'image':
            formatedData.media[fld.name] = data[fld.name].value;
            break;

          case 'logo':
            formatedData.logo = (0, _logoUtils.normalizeLogoObject)(data[fld.name]);
            break;

          case 'text':
            if (data[fld.name].value) {
              formatedData.values[fld.name] = data[fld.name].value;
            }

            break;

          default:
            formatedData.values[fld.name] = data[fld.name];
        }
      }
    });
  }

  return formatedData;
}

function normalizeCaptionObject(caption) {
  const {
    timing,
    guid,
    children,
    type
  } = caption;
  let lottie = getFirstItemByLayout(children, 'lottie');

  if (!lottie) {
    lottie = getFirstItemByLayout(children, 'lottietrustpilot');
  }

  const {
    name,
    value
  } = lottie.data;
  const isoutro = isOutro(caption);
  const config = getConfigByName(name, caption.type);
  let data = formatDataByConfig(caption, lottie.data, config, isoutro);
  data.textTransform = getTextTransform(lottie);

  if (caption.type === 'template2') {
    data = { ...data,
      ratio: config.ratio,
      duration: config.inDuration,
      inputs: config.inputs,
      value
    };
  } else if (!isoutro) {
    data = { ...data,
      value
    };
  } else {
    data = { ...data,
      inputs: config.inputs,
      values: getOutroInputs(lottie),
      logo: (0, _logoUtils.normalizeLogoObject)(lottie.data.logo)
    };
  }

  return {
    type,
    guid,
    timeline: {
      start: timing.start,
      end: timing.end
    },
    data
  };
}

function sortCaptions(captions) {
  const newCaptionsArray = [...captions];
  return newCaptionsArray.sort((a, b) => a.timing.start - b.timing.start);
}

function getLastCaptionByType(captions, type) {
  return _.findLast(captions, caption => caption.type === type);
}

function getCaptionsByType(captions, type) {
  return captions.filter(caption => caption.type === type);
}

function getCaptionStyles(caption) {
  const data = getFirstItemByLayout(caption.children, 'lottie').data;

  const cloneData = _.pick(data, ['name', 'inDuration', 'outDuration', 'id', 'textAlign', 'colors', 'fonts', 'textTransform', 'style']);

  delete cloneData.style.x;
  delete cloneData.style.y;
  return cloneData;
}

function isFontSupport(fonts, templateData) {
  let fontSupport = true;
  fonts.forEach(font => {
    const excludeFont = _.find(templateData.excludeFonts, {
      font: font.font
    });

    if (excludeFont !== undefined && excludeFont.weights.indexOf(font.weight) !== -1) {
      fontSupport = false;
    }
  });
  return fontSupport;
}

function setCaptionFont(lottie, font) {
  lottie.data.fonts = [font];
  return lottie;
}

function setCaptionColors(lottie, colors) {
  const {
    foreground,
    background
  } = colors;

  if (foreground) {
    lottie.data.colors[0] = (0, _color.default)(foreground).rgb().string();
  }

  if (background) {
    lottie.data.colors[1] = (0, _color.default)(background).rgb().string();
  }

  return lottie;
}

function setColorsByKey(lottie, colors) {
  if (colors.hasOwnProperty('foreground') || colors.hasOwnProperty('background')) {
    setCaptionColors(lottie, colors);
  } else {
    Object.keys(colors).forEach(key => {
      lottie.data[key].value = (0, _color.default)(colors[key]).rgb().string();
    });
  }

  return lottie;
}

function setCaptionTextTransform(lottie, textTransform) {
  if (isOutro(lottie)) {
    // set all outro data
    Object.keys(_outroInputs.default).forEach(atrr => {
      lottie.data[atrr].textTransform = textTransform;
    });
  } else {
    // set caption textTransform
    lottie.data.textTransform = textTransform;
  }

  return lottie;
}

function setCaptionAnimation(lottie, templateData, timing) {
  const {
    data
  } = lottie;
  const {
    name,
    inDuration,
    outDuration,
    template
  } = templateData;
  let {
    isStatic
  } = templateData;
  let animationID;
  let inD = inDuration;
  let outD = outDuration;

  if (isOutro(lottie)) {
    animationID = template.outro[data.textAlign];
  } else {
    animationID = template.caption[data.textAlign];

    if (timing !== undefined) {
      const diff = timing.end - timing.start;

      if (diff < 3) {
        inD = 1;
        outD = 0;
      }
    }
  }

  if (isStatic === undefined) {
    isStatic = false;
  }

  lottie.data = { ...data,
    name,
    inDuration: inD,
    outDuration: outD,
    id: animationID,
    isStatic
  };
  return lottie;
}

function setCaptionTextAlign(lottie, alignment) {
  lottie.data.textAlign = alignment;
  return lottie;
}

function resetCaptionFonts(lottie) {
  lottie.data.fonts = [];
  return lottie;
} // set caption position and size


function setCaptionStyle(lottie, rect) {
  const pick = _.pick(rect, 'x', 'y', 'width', 'height');

  lottie.data.style = { ...lottie.data.style,
    ...pick
  };
  return lottie;
}

function setCaptionValue(lottie, value) {
  const lines = value.replace(new RegExp('&nbsp;', 'g'), '\u00a0').replace(/\r|\n|(\n\r)/ig, '<br>').replace(/<br>$/, '').split(/<br>/g);
  let text = '';
  lines.forEach(line => {
    text += `${line.replace(/\s+$/, '')}<br>`;
  });
  lottie.data.value = text.replace(/<br>$/, '');
  return lottie;
}

function setOutroValue(lottie, values) {
  Object.keys(values).forEach(key => {
    const value = values[key]; // set value and remove space in the end

    lottie.data[key].value = value.replace(new RegExp('&nbsp;', 'g'), '\u00a0').replace(/\s+$/, '');
  });
  return lottie;
}

function setInputsValue(lottie, values) {
  Object.keys(values).forEach(key => {
    const value = values[key];
    const fldType = typeof lottie.data[key]; // set value and remove space in the end

    if (fldType === 'object') {
      lottie.data[key].value = value.replace(new RegExp('&nbsp;', 'g'), '\u00a0').replace(/\s+$/, '');
    } else {
      lottie.data[key] = value.replace(new RegExp('&nbsp;', 'g'), '\u00a0').replace(/\s+$/, '');
    }
  });
  return lottie;
}

function setMedia(lottie, mediaObj) {
  Object.keys(mediaObj).forEach(key => {
    const media = mediaObj[key];
    lottie.data[key].value = media.value;
  });
  return lottie;
}

function setTemplateLogo(lottie, logoObj) {
  const {
    value,
    id
  } = logoObj;
  const {
    data: {
      logo
    }
  } = lottie;
  logo.value = value;
  logo.id = id;
  return lottie;
}

function pushOutroTiming(data, lastCaptionEndTime) {
  const outro = getOutro(data); // check if need to push outro

  if (outro.timing.start <= lastCaptionEndTime) {
    // need to push outro
    const outroDuration = outro.timing.end - outro.timing.start;
    const newOutroTiming = {
      start: lastCaptionEndTime + CAPTION_GAP_TIME,
      end: lastCaptionEndTime + CAPTION_GAP_TIME + outroDuration
    };
    outro.timing = newOutroTiming;
  }
}

function getNewCaptionTiming(data, duration) {
  // get the last caption by type
  const lastCaption = getLastCaptionByType(data, 'caption');
  const lastCaptionEndTime = lastCaption ? lastCaption.timing.end : 0; // set caption times

  return {
    start: lastCaptionEndTime + CAPTION_GAP_TIME,
    end: lastCaptionEndTime + CAPTION_GAP_TIME + duration
  };
}

function getCaptionTrimStartOptions(data, index) {
  const stops = [];
  let captionsDuration = 0;
  const currentStart = data[index].timing.start;
  const currentEnd = data[index].timing.end;

  for (let i = index - 1; i >= 0; i--) {
    const guid = data[i].guid;
    const {
      start,
      end
    } = data[i].timing;
    const obj = {
      guid,
      time: (0, _mathUtils.fixedNum)(end + captionsDuration, 2)
    };
    captionsDuration += end - start;
    stops.push(obj);
  }

  return {
    negative: (0, _mathUtils.fixedNum)(currentStart - (currentStart - captionsDuration), 2),
    positive: (0, _mathUtils.fixedNum)(currentEnd - CAPTION_MIN_TIME, 2),
    stops
  };
}

function getCaptionTrimEndOptions(data, index, maxTime) {
  const stops = [];
  let captionsDuration = 0;
  const currentStart = data[index].timing.start;

  for (let i = index + 1; i < data.length; i++) {
    const guid = data[i].guid;
    const {
      start,
      end
    } = data[i].timing;
    const obj = {
      guid,
      time: (0, _mathUtils.fixedNum)(start - captionsDuration, 2)
    };
    captionsDuration += end - start;
    stops.push(obj);
  }

  return {
    negative: (0, _mathUtils.fixedNum)(currentStart + CAPTION_MIN_TIME, 2),
    positive: (0, _mathUtils.fixedNum)(maxTime - captionsDuration, 2),
    stops
  };
}

function getCaptionDragTimeOptions(data, index, minTime, maxTime) {
  const stops = [];
  const caption = data[index];
  const captionDuration = caption.timing.end - caption.timing.start;

  if (isOutro(caption)) {
    return {
      negative: minTime,
      // need to pass the relvent min time clip or last caption
      positive: (0, _mathUtils.fixedNum)(maxTime - captionDuration, 2),
      stops
    };
  } // for all other caption need to set stops


  const outro = getOutro(data);
  const captionStart = caption.timing.start;
  const captionEnd = caption.timing.end;
  const captionGapFromStart = index > 0 ? captionStart - data[index - 1].timing.end : 0;
  const captionGapFromEnd = data[index + 1].timing.start - captionEnd;

  for (let i = 0; i < data.length; i++) {
    const guid = data[i].guid;

    if (!isOutro(data[i]) && guid !== caption.guid) {
      const {
        start,
        end
      } = data[i].timing;
      let effectTime = start + (end - start) * 0.5;
      const moveTo = {};

      if (start > captionStart) {
        effectTime -= captionDuration;
        moveTo.start = (0, _mathUtils.fixedNum)(start - (captionDuration + captionGapFromEnd), 2);
        moveTo.end = (0, _mathUtils.fixedNum)(end - (captionDuration + captionGapFromEnd), 2);
      } else {
        moveTo.start = (0, _mathUtils.fixedNum)(start + (captionDuration + captionGapFromStart), 2);
        moveTo.end = (0, _mathUtils.fixedNum)(end + (captionDuration + captionGapFromStart), 2);
      }

      const obj = {
        guid,
        time: (0, _mathUtils.fixedNum)(effectTime, 2),
        moveTo
      };
      stops.push(obj);
    }
  }

  return {
    negative: minTime,
    positive: (0, _mathUtils.fixedNum)(outro.timing.start - captionDuration, 2),
    stops
  };
}

function getCaptionByTime(data, time) {
  let index = 0;
  let guid;

  while (!guid && data[index]) {
    const caption = data[index];
    const {
      start,
      end
    } = caption.timing;

    if (time >= start && time <= end) {
      guid = caption.guid;
    }

    index++;
  }

  return guid;
}

function getReportOutroFields(lottie) {
  const fields = getOutroInputs(lottie);
  const report = {};
  Object.keys(fields).forEach(item => {
    report[`outro_has_${item}`] = !!fields[item];
  }); // add background

  report.outro_has_background = lottie.data.background.type !== 'color';
  return report;
}

function getCaptionValueWithoutLineBreak(item) {
  if (isOutro(item)) {
    return `${item.data.action_01} ${item.data.action_02}`;
  }

  if (isTemplate2(item)) {
    return `${item.data.action_01}`;
  }

  return item.data.value.replace(/<br>/g, ' ').replace(/\s+/g, ' ').trim();
}

function getCaptionsPropsForReports(captions) {
  const ROUND_CAPTIONS_BY = 0.5;
  let props = {
    numCaptions: 0,
    withYourTextGoesHere: false,
    captions: []
  };
  const animations = [];
  const animationArray = [];
  const textTransformArray = [];
  let fontArray = [];
  let countAnimations = [];
  const DEFAULT_CAPTION_TEXT = 'YOUR TEXT GOES HERE';
  const captionsDurations = [];
  captions.forEach(caption => {
    props.numCaptions++;
    const lottie = getFirstItemByLayout(caption.children, 'lottie');
    const textTransform = getTextTransform(lottie);

    if (!isOutro(lottie)) {
      props.captions.push(getCaptionValueWithoutLineBreak(lottie));
    }

    const {
      name,
      fonts
    } = lottie.data;
    animations.push({
      animationId: name,
      font: fonts,
      textTransform
    });
    textTransformArray.push(textTransform);
    animationArray.push(name);
    fontArray = [...fontArray, ...fonts];
    countAnimations.push(name);

    if (isOutro(lottie)) {
      props.outro = lottie.data.name;
      props = { ...props,
        ...getReportOutroFields(lottie)
      };
    }

    if (getCaptionValueWithoutLineBreak(lottie) === DEFAULT_CAPTION_TEXT) {
      props.withYourTextGoesHere = true;
    }

    captionsDurations.push(caption.timing.end - caption.timing.start);
  });
  const totalCaptionsDuration = captionsDurations.reduce((total, duration) => total + duration, 0);
  countAnimations = _.uniq(countAnimations);
  return { ...props,
    firstCaptionStartSec: (0, _mathUtils.numberRound)('round', captions[0].timing.start, ROUND_CAPTIONS_BY),
    captionAvgDuration: (0, _mathUtils.numberRound)('round', totalCaptionsDuration / captions.length, ROUND_CAPTIONS_BY),
    shortestCaptionDuration: (0, _mathUtils.numberRound)('round', Math.min(...captionsDurations), ROUND_CAPTIONS_BY),
    longestCaptionDuration: (0, _mathUtils.numberRound)('round', Math.max(...captionsDurations), ROUND_CAPTIONS_BY),
    captionStyleArray: animations,
    fontArray,
    animationArray,
    textTransformArray,
    countOfUniqueAnimationUsed: countAnimations.length
  };
}

function validateCaptionSizeAndPosition(rect, baseSize, stageSize) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  rect.x = (0, _mathUtils.fixedNum)(Math.min(stageSize.width - 100, Math.max(100 - width, x)), 0);
  rect.y = (0, _mathUtils.fixedNum)(Math.min(stageSize.height - 100, Math.max(100 - height, y)), 0);
  const baseWidth = baseSize.width;
  const baseHeight = baseSize.height;
  const limit = 50;

  if (width < limit) {
    let limitRect = (0, _mathUtils.sizeByWidth)(limit, baseWidth, baseHeight);

    if (limitRect.height < 50) {
      limitRect = (0, _mathUtils.sizeByHeight)(limit, baseWidth, baseHeight);
    }

    rect.width = (0, _mathUtils.fixedNum)(limitRect.width, 0);
    rect.height = (0, _mathUtils.fixedNum)(limitRect.height, 0);
  }

  if (height < limit) {
    let limitRect = (0, _mathUtils.sizeByHeight)(limit, baseWidth, baseHeight);

    if (limitRect.width < 50) {
      limitRect = (0, _mathUtils.sizeByWidth)(limit, baseWidth, baseHeight);
    }

    rect.width = limitRect.width;
    rect.height = limitRect.height;
  }

  return rect;
}

function getCaptionFont(lottie) {
  return lottie.data.fonts[0];
}